import React, { useState, useEffect } from "react";
import axios from "axios";
import PageComposer from "./PageComposer";

const ManagePages = () => {
    const [pages, setPages] = useState([]);
    const [selectedPage, setSelectedPage] = useState(null);

    const fetchPages = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get("/api/pages", {
                headers: { Authorization: `Bearer ${token}` },
            });
            setPages(response.data);
        } catch (error) {
            console.error("Error fetching pages:", error);
        }
    };

    useEffect(() => {


        fetchPages();
    }, []);

    const handleDelete = async (slug) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this page?");
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem("token");
            await axios.delete(`/api/pages/${encodeURIComponent(slug)}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setPages(pages.filter((page) => page.slug !== slug));
        } catch (error) {
            console.error("Error deleting page:", error);
            alert("Failed to delete the page. Please try again.");
        }
    };


    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Manage Pages</h2>
            {selectedPage ? (
                <PageComposer
                    existingPage={selectedPage}
                    onSave={() => {
                        setSelectedPage(null);
                        fetchPages(); // Refresh the list
                    }}
                    onCancel={() => setSelectedPage(null)}
                />
            ) : (
                <>
                    <button
                        onClick={() => setSelectedPage({})}
                        className="bg-green-500 text-white px-4 py-2 rounded mb-4"
                    >
                        Create New Page
                    </button>
                    <ul>
                        {pages.map((page) => (
                            <li key={page._id} className="border p-4 rounded mb-4">
                                <h3>{page.title}</h3>
                                <p>Slug: {page.slug}</p>
                                <button
                                    onClick={() => setSelectedPage(page)}
                                    className="bg-blue-500 text-white px-4 py-2 rounded"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(page.slug)}
                                    className="bg-red-500 text-white px-4 py-2 rounded ml-4"
                                >
                                    Delete
                                </button>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default ManagePages;
